<template>
  <div class="service">
    <h2>Mobile Terms of Service</h2>

    <p>Effective Date: 2th November, 2022.</p>

    <p>
      Thank you for using mobile service of Hong Kong Hookylin Technology Limited. Hong Kong Hookylin Technology Limited
      always tries to make mobile service easier and more convenient for you and we will do our best to provide better
      service to you in the future. These Terms and Conditions are common to Mobile Service provided by Hong Kong
      Hookylin Technology Limited and we have collected the content you need to know in one place.
    </p>

    <p>
      Please read these Terms and Conditions carefully because they govern your access to and use of our Services
      (defined below) and Content (defined below) and are legally binding. You acknowledge and agree that by accessing
      or using our Services or by downloading or posting any content on or through our Services, you are indicating that
      you have read, understand and agree to be bound by these terms, whether or not you have registered as a User
      (defined below).
    </p>

    <p>
      If you do not agree to this Agreement or any of its provisions, please stop using our Services immediately, and we
      will no longer be able to provide Services to you. Users under the age of 18 or whatever the age of legal majority
      where they access the Service is should read this Agreement with their parents or guardians, and seek the consent
      and guidance of their parents or guardians before submitting personal information.
    </p>

    <h3>Article 1 Purpose</h3>

    <p>
      These Terms and Conditions (“Agreement”) are aimed to specify rights, responsibilities and other necessary matters
      between Hong Kong Hookylin Technology Limited (“Company”, “we”, “our” or “us”) and Users (“you” or “User”) with
      respect to the Service provided by Hong Kong Hookylin Technology Limited.
    </p>

    <h3>Article 2 Definition of Terms</h3>

    <p>
      1) The terms used in these Terms and Conditions are as follows.<br />
      1. “Content” means the application provided by the Company.<br />
      2. “Mobile Device” means mobile phone, tablet, PC, portable game machine or other devices that can download,
      install and use digital content, or devices that can be used through network.<br />
      3. “Service” or “Services” means any service that the Company provides to the Content on the “Mobile Device”.<br />
      4. “ID” means the combination of letters and numbers selected by the user and approved by the Company for user
      identification within the “Service”. <br />
      5. “Password” means the combination of letters and numbers selected by “User” to determine whether the “User” has
      the right to access “ID”. <br />
      6. “User” means the user who agrees to these Terms and register to create an account to use the “Service”.<br />
      7. “User Content” means information, data, software, sound, photographs, graphics, video, messages, tags, or other
      materials that may be sent, uploaded, communicated, transmitted or otherwise made available via our “Services” by
      “Users”.<br />
      8. “Open Market” means application trading sites (Google Play Store, Apple App Store, etc.) operated by “Open
      Market Operators” (Google, Apple, etc.). <br />
      9. “Open Market Operator” means an electronic commerce company that provides the installation and payment
      functions of “Content”.<br />
      10. “Payment Provider” means a provider of electronic payment which is available for “Open Market” such as credit
      card, mobile phone payment, etc.<br />
      11. “Virtual Currency” means any virtual, in-game currencies such as gold coins and gems in our “Service”,
      including by purchasing a limited license to “Virtual Currency” for a fee.<br />
      12. “Virtual Good” means any virtual, in-game digital items in our “Service”, including by purchasing a limited
      license to the “Virtual Goods” that may be paid for with “real world” money or “Virtual Currency”.<br />
      13. “Location Information” means information about a place or place where a movable object or an individual exists
      or exists at a specific time. <br />
      14. “Personal Location Information” means "Location Information” of a specific individual (even if the location of
      the specific person is not known only by the Location Information, it includes the ability to know the location of
      a specific individual by easily combining with other information).<br />
      15. “Personal Location Information Subject” means the person identified by “Personal Location Information”.<br />
      16. “Location Based Services” means the “Services” provided by Company utilizing “Location Information” or
      “Personal Location Information”.
    </p>

    <p>2) Terms that are not defined in these Terms and Conditions shall be governed by laws and regulations.</p>

    <h3>Article 3 Effect and Change of Terms</h3>

    <p>
      1) In the event of a reasonable cause, the Company may amend, modify or revise these Terms and Conditions to the
      extent not inconsistent with the relevant laws and regulations.
    </p>

    <p>
      2) You agree to check periodically for new terms. You may terminate your agreement if you do not agree to the
      changed terms. Please note that your continued use of our Services shall constitute your acceptance to be bound by
      the newly updated Terms and Conditions.
    </p>

    <p>
      3) The Company shall not be held responsible for any damage caused by failure to know the information about the
      changed Terms.
    </p>

    <p>4) These Terms and Conditions become effective upon your agreement to this Agreement.</p>

    <h3>Article 4 Application for Service Use and Approval</h3>

    <p>
      1) In order to become a User of our Service, you need to complete the registration process and are required to
      provide personal information necessary for the Company to provide the Service, including but not limited to your
      email address. You agree to provide accurate, current and complete information during the registration process and
      to update such information to keep it accurate, current and complete.
    </p>

    <p>
      2) If the information you provide is inaccurate, or untrue, or not legally valid, or has been changed and not
      updated, or is in any way misleading, we reserve the right to suspend or terminate your access to any of our
      Services until you provide information that meets the requirements. We will notify you of the suspension and the
      period of suspension, which shall be reasonable, and we will promptly restore the Services to you upon expiration
      of the period of suspension.
    </p>

    <p>
      3) You should be legally responsible for all activities and events carried out under your account. We shall not be
      liable for any illegal use of the User's account or password, or any consequences arising therefrom, due to the
      User’s negligence or any third party’s actions.
    </p>

    <p>
      4) You agree that if you are under the age of 18 or whatever the age of legal majority where you access the
      Service is, you represent that your legal guardian has read, understood, and agreed to this Agreement. In
      registering to become a User of our Service and Content, you agree to monitor the usership to restrict any use by
      minors. You accept full responsibility for any unauthorized use of our Services by minors, and this includes any
      use of your credit cards or other payment or settlement instruments or devices by minors.
    </p>

    <p>
      5) In principle, the Company will approve the use of the Service in accordance with the order of application.
      However, in the cases listed below, acceptance can be held until the cause is resolved. <br />
      1. If the facilities of the Company are not available;<br />
      2. Technical difficulties;<br />
      3. Difficulty in accepting the use because of other situations of the Company.
    </p>

    <p>
      6) The Company may not approve or may limit the use of the Service for the following cases: <br />
      1. Stealing information or Mobile Devices from others;<br />
      2. Using the Service for violating any relevant laws or regulations;<br />
      3. Using the Service for the purpose of pursuing profit;<br />
      4. Using the Service for the purpose of hindering the interests of the Company.<br />
      6. When a Company applies for Service in Mobile Device for which Service is restricted. <br />
      7. Applying in violation of other regulations prescribed by the Company.
    </p>

    <p>
      7) Company shall allow the Service to be used immediately when Users complete the entry of the personal
      information required to use the Service if there is nothing to suspend or deny the acceptance. However, if there
      is any disagreement about the acceptance after the end of the contract, there will be limits or contract
      termination according to the provisions of this Agreement.
    </p>

    <h3>Article 5 Obligations of the Company</h3>

    <p>
      1) The Company does its best to provide the Service continuously and reliably and ensures that it has a security
      system so that the Service can be used safely.
    </p>

    <p>
      2) The Company shall promptly process the opinions or complaints raised by Users as appropriate, if they are
      objectively recognized as fair. However, if it is difficult to process immediately, there will be a notice about
      reasons and processing schedule that are difficult to process immediately.
    </p>

    <p>
      3) The Company reserves the right, but is not obligated, to mediate, resolve, or otherwise get involved in
      disputes between Users.
    </p>

    <h3>Article 6 Obligations of Users</h3>

    <p>
      1) Users shall comply with the relevant laws and regulations such as the matters stipulated in these Terms and
      Conditions, operational policies and restrictions on use, matters notified by the Company and other regulations
      set by the Company.
    </p>

    <p>
      2) Users shall not engage in acts that interfere with the work of the Company, or impair the honor of the Company.
    </p>

    <p>
      3) Users shall not conduct business activities using the Service without the prior consent of the Company, and the
      Company shall be held liable for the results of the business activities. In the event of a loss to the Company as
      a result of any unauthorized business activity, the Company may claim damages against the Users.
    </p>

    <p>
      4) Users hold responsibility for the management of their Mobile Device, ID, and Password. The Company shall not be
      liable for any damages arising from the negligence of management of Mobile Device, ID, Password, or the use of
      Mobile Device, ID, Password by third parties.
    </p>

    <p>
      5) Users shall not, in any way, claiming to be our employees or disseminating false information either to the
      Company or third parties, spreading vulgar information, posting illegal websites, spam advertisements or any
      information or materials involving drugs or otherwise attack, threaten or insult a portion or all of the Users.
    </p>

    <p>
      6) Users shall not, directly or indirectly, use any vulgar expressions, coarse language, or engage in any abusive
      behavior, verbal harassment, either towards the Company or other Users.
    </p>
    <p>7) Users shall not use any unapproved payment methods.</p>

    <p>8) Users shall not use any cheating programs or other malicious game programs.</p>

    <p>
      9) Users shall not engage in the dissemination of information or materials that violate customs, religious
      beliefs, habits or social morality of a portion or group of the public.
    </p>

    <p>
      10) Users shall not disclose, furnish, disseminate or otherwise make any of our or other Users' non-public
      information available to third parties.
    </p>

    <p>
      11) The Company may set up the specific type of matters that mentioned as following and Users have an obligation
      to comply: <br />
      1. Limitations on account name, character name, and guild name;<br />
      2. Limits on chat content and methods;<br />
      3. Restrictions on the use of bulletin boards;<br />
      4. Limitations on how to play the game;<br />
      5. Other matters that the Company deems necessary for the Service operation to the extent that it does not
      infringe the essential rights of Users to use the Service.
    </p>

    <h3>Article 7 Operational Policy and Restrictions on Use</h3>

    <p>
      The Company may establish operating policies or restrictions on how the Service is used in order to protect the
      interests of Users and to maintain order in the Service.
    </p>

    <h3>Article 8 Availability of the Services</h3>

    <p>
      1) The Service shall be provided for a fixed period of time in accordance with the Company’s business policy. If
      there is no separate sign nor notice, it will be provided 24 hours a day.
    </p>

    <p>
      2) Notwithstanding the provisions of Paragraph 1, the Service may not be provided and Company is not obliged to
      provide Service in the following cases:<br />
      1. Equipment inspection, replacement, periodic inspection or necessary for the modification of Contents or
      Service.<br />
      2. When it is necessary to cope with intrusion accidents such as hacking, unusual usage behavior of User, and
      instability of unpredictable Service.<br />
      3. When it is not possible to provide normal Services under circumstances such as natural disasters, wars,
      emergencies, power outages, equipment failures, network disturbances.<br />
      4. When any relevant law or regulation requires that certain User is prohibited from the Service provided.
    </p>

    <p>
      3) The Company may change all or part of the Services at any time if necessary for the operation of the Services
      such as new Content, bug patches, etc. The Company shall not be liable for any damages such as loss of the
      expected profit of Users caused by the change of Service or loss of benefit not provided directly by the Company.
    </p>

    <p>
      4) Notwithstanding anything to the contrary, you acknowledge and agree that any or all of our services may be
      terminated in whole or in part at our sole discretion without notice to you. You assume any and all risk of loss
      associated with the termination of our services.
    </p>

    <h3>Article 9 Limitation of Service Use</h3>

    <p>
      Users shall not engage in any activity including but no limited to the followings. In the event of such conduct,
      the Company shall limit the use of the Service of the Users, delete the related information (articles, photos,
      video, etc.) and make usage restriction which legal measures are included. The Users are responsible for the
      problems caused.<br />
      1. Registering with false information or enraging others when registering or changing information.<br />
      2. Stealing information or Mobile Devices from others.<br />
      3. Changing the Program of Company without prior notice from the Company, hacking the server of the Company,
      changing any part or all of the website or published information or using the Service of Company in an abnormal
      way.<br />
      4. Abusing of program bugs.<br />
      5. Acquisition and use of cyber assets (ID, characters, items, Virtual Goods, Virtual Currency, etc.) in a way
      that is unusual.<br />
      6. Transferring or trading cyber assets.<br />
      7. Doing harm to the Service or intentionally interfering with Service.<br />
      8. Doing business by using the Service without prior consent of the Company. <br />
      9. Reproducing the information obtained through the Service for purposes other than the use of the Service without
      the prior consent of the Company and using it for publication or broadcasting, or providing it to a third
      party.<br />
      10. Spreading any infringement of patents, trademarks, trade secrets, copyrights, or other intellectual property
      rights of others to others through transmitting, posting or other means.<br />
      11. Spreading information, statements, drawings, sounds, or videos of vulgar or obscene content that are in
      violation of relevant laws or regulations through transmitting, posting or other means.<br />
      12. Spreading content that may infringe on the honor or privacy of others, including content that is extremely
      offensive or related to personal details through transmitting, posting or other means.<br />
      13. Harassing or intimidating other Users or causing continued suffering or discomfort to a particular User.<br />
      14. Actions that may affect game results, such as tampering with the game or forcibly terminating the game.<br />
      15. Actions that are objectively judged to be connected with a crime.<br />
      16. Other actions which violate relevant laws and regulations.
    </p>

    <h3>Article 10 Protection and Use of Personal Information</h3>

    <p>
      1) The protection and use of personal information shall be governed by the relevant laws and regulations and the
      Company's Privacy Policy. However, the Company’s Privacy Policy does not apply to services which are not provided
      by the Company. Therefore, please check the Privacy Policy of the third party when linking your account to a third
      party or using services provided by a third party.
    </p>

    <p>
      2) Depending on the nature of the Service, the User’s introduction may be exposed to other Users, such as
      nicknames, photos, etc.
    </p>

    <p>
      3) If you do not agree to our Privacy Policy, you should not download, use or access any of our Content or
      Service.
    </p>

    <h3>Article 11 Collection of Information</h3>

    <p>
      1) In order to operate and stabilize the Service and to improve the quality of the Service, device information,
      device identification number, MAC address, OS information and version, Affiliated communication company
      information that has being used, Service usage details of User, etc. can be collected by the Company.
    </p>

    <p>
      2) The Company may store or view chat content between users within Services provided by the Company. The Company
      reserves the right to view the chat information only when it is deemed necessary by the Company to adjust the
      disputes, handle complaints, or maintain the order of the Service.
    </p>

    <p>
      3) The Company may retain customer inquiries/consultations (e-mail, chat, etc.) for customer support for Users.
      The information stored is used for customer support purposes only and is discarded after the purpose of use is
      achieved in principle. However, information that needs to be archived according to laws and regulations is kept in
      accordance with the standards set by laws and regulations.
    </p>

    <h3>Article 12 Providing Advertising and Transactions with Advertisers</h3>

    <p>
      1) A portion of the Services investment base from which the Company can provide Services to Users comes from
      profits from ad serving. Users who wish to use the Service shall be deemed to agree to the advertising they are
      exposed to when using the Service.
    </p>

    <p>
      2) Users acknowledge and authorize that our Services may contain third parties’ commercials or promotional
      advertisements. Such content is provided by the advertiser or provider of the goods or services, who takes full
      responsibility. The transaction of such services or goods purchased by Users through us or websites linked to us
      is between Users and the providers of such goods or services, and is not related to us. Therefore, we do not
      assume any legal responsibility for the transaction mentioned above, and Users should carefully judge the
      authenticity and reliability of the advertisements appearing in the Service, and except as expressly provided by
      law, Users shall be responsible for the acts performed as a result of such advertisements.
    </p>

    <p>
      3) The Company shall not be liable for any loss or damage arising as a result of Users’ participating in or
      communicating with or being involved in an advertiser's promotional activity posted on the Service or through the
      Service.
    </p>

    <h3>Article 13 Content License</h3>

    <p>
      1) Subject to your compliance with this Agreement, we hereby grant you a limited, revocable, non-exclusive,
      non-transferable and non-sublicensable license to access, view, download and print, where applicable, any of our
      Content solely for your personal and non-commercial purposes. You will not use, copy, adapt, modify, prepare
      derivative works based upon, distribute, license, sell, transfer, publicly display, publicly perform, transmit,
      stream, broadcast or otherwise exploit the Service or our Content, except only as expressly permitted by this
      Agreement. No licenses or rights are granted to you by implication or otherwise under any Intellectual Property
      Rights owned or controlled by the Company or its licensors, except for the licenses and rights expressly granted
      by this Agreement.
    </p>

    <p>
      2) By accepting this Agreement, you understand and acknowledge that our Content is licensed, not sold to you,
      under the license, and furthermore that the license does not grant you any title or ownership in our Content.
    </p>

    <p>
      3) Except as permitted by law or regulation or with our prior written permission, you may not, on your own or with
      the consent, authority or direction of any third party, do any of the following.<br />
      1. You shall not reverse engineer, disassemble, decompile or by any means attempt to extract source code from our
      Service in whole or in part, or delete or modify the computer system of the Service. <br />
      2. You shall not copy, change, modify, hook up, run or create any derivative works of the Service or any data
      released during the operation of the Service and the interaction data between the client and the server during the
      operation of the Service, including but not limited to the use of plug-ins or non-authorized third-party tools or
      services to access the Service and related systems.<br />
      3. You may not use any bot, web spider, web crawler, crawler tool, site search/retrieval application or other tool
      to access, crawl, pre-read, store, cache, screenshot, retrieve or index any part of the Service and related
      Content, or to circumvent or attempt to circumvent the Service and any security protection mechanisms or system
      defenses provided by us in any way, by any tools or other system configurations.<br />
      4. You may not use the Service to charge or for profit, whether or not for direct financial or monetary gain;
      and<br />
      5. You may not perform any act that alters or attempts to alter our system configuration for the Service.<br />
      6. You may not stress test the Service or affect the stability of our Services, etc.
    </p>

    <p>
      4) If we find or receive reports or complaints from others that you have violated the laws, regulations or this
      agreement to use our Service, we have the right to take necessary measures based on the nature of your behavior,
      including but not limited to suspending or terminating all or part of Service to you, blocking your account,
      zeroing out the account amount, restricting re-registration, clearing data, and pursuing legal responsibility,
      etc.. In addition, you may be subject to criminal and administrative liability and other legal consequences.
    </p>

    <p>
      5) You understand and agree that you shall be solely responsible for any claims, demands or losses asserted by
      third parties arising out of or resulting from your violation of laws, regulations or this Agreement, and that if
      we suffer damages as a result, you shall pay them as well, including but not limited to all claims, losses,
      damages (actual and consequential damages), fines, and corresponding litigation costs and attorneys' fees paid by
      us.
    </p>

    <h3>Article 14 User Content</h3>

    <p>
      1) By making available any User Content on or through our Services, you hereby grant to us a worldwide,
      irrevocable, perpetual, non-exclusive, transferable, royalty-free license, with the right to sublicense, use,
      copy, adapt, modify, distribute, license, sell, transfer, publicly display, publicly perform, transmit, stream,
      broadcast and otherwise exploit such User Content only on, through or by means of our Services.
    </p>

    <p>
      2) The Company does not claim any ownership rights in any User Content. You understand and agree that all User
      Content that you may be sent when using our Services, whether publicly posted or privately sent, is the sole
      responsibility of the person that sent the User Content. This means that you, not us, are entirely responsible for
      all Content that you may upload, communicate, transmit or otherwise make available via our Services.
    </p>

    <p>
      3) The Company does not control User Content posted on our Services by Users and therefore we do not guarantee the
      accuracy, integrity or quality of that Content. You understand that when using our Services, you may be exposed to
      User Content that you may consider offensive, indecent or objectionable. Under no circumstances will the Company
      be liable in any way for any User Content, including, but not limited to, any errors or omissions in any User
      Content, or any losses or harm of any kind resulting from the use of any User Content posted, emailed, transmitted
      or otherwise made available via our Services.
    </p>

    <p>
      4) The Company has the right to remove uploaded User Content from our Services if we decide in our sole discretion
      that it results in or from a breach of any part of these terms, or that it may bring us or our Services into
      disrepute. However, you acknowledge that we do not actively monitor User Content that is contributed by Users and
      we make no undertaking to do so.
    </p>

    <p>
      5) You are solely responsible for your interactions with other Users of our Services. The Company shall not be
      liable for any loss or damage arising from the User Content (yours or another User's) including without limitation
      in respect of any defamation, harassment, or false endorsement claims.
    </p>

    <p>
      6) You shall not, on your own or with your consent, authorize or instruct any third party to use our Service to
      upload, store, post, publish, display, share, transmit, or distribute any content that is illegal and that you do
      not have authorization for, including but not limited to, the following: <br />
      1. Inciting ethnic hatred, ethnic discrimination, and undermining ethnic unity;<br />
      2. Spreading rumors, disrupting social order, and disrupting social stability;<br />
      3. Spreading obscenity, pornography, gambling, violence, homicide, terror or instigate crime;<br />
      4. Insulting or slandering others, and infringing on the legitimate rights and interests of others;<br />
      5. Containing content that is false, harmful, coercive, invasive of other's privacy, harassing, offensive,
      libelous, vulgar, obscene, or otherwise morally objectionable.<br />
      6. Content for which you do not have ownership rights, intellectual property rights or are not legally
      authorized;<br />
      7. Any other information that is illegal or contains other content that is restricted or prohibited by any law or
      regulation.
    </p>

    <h3>Article 15 Virtual Currency and Virtual Goods</h3>

    <p>
      1) You agree that if you are under the age of 18 or whatever is the age of legal majority where you access the
      services, you may make payments only with the involvement of your legal guardian, and you represent that your
      legal guardian has read, understood, and agreed to these Terms and Conditions.
    </p>

    <p>
      2) The Service may include an opportunity for you to acquire virtual, in-game currency ("Virtual Currency"),
      including by purchasing a limited license to Virtual Currency for a fee. The Service may also include the
      opportunity to acquire virtual, in-game digital items ("Virtual Goods"), including by purchasing a limited license
      to the Virtual Goods that may be paid for with “real world” money or Virtual Currency.
    </p>

    <p>
      3) Your right to use any Virtual Goods and Virtual Currency that you obtain is limited to a limited,
      non-exclusive, non-assignable, non-transferable, non-sublicensable, revocable license to use such Virtual Goods
      and Virtual Currency solely for your personal entertainment and non-commercial use in the Services only. You have
      no property interest or right or title in any Virtual Goods or Virtual Currency, which remain the Company’s
      property. The Company reserves the right to reverse, change or amend Virtual Goods or Virtual Currency
      transactions or other matters, if necessary, to protect the Services and/or to enforce this Agreement. Any access
      or use of Virtual Currency or Virtual Goods not specifically permitted by this Agreement is a violation of this
      Agreement and may result in a termination of your Account. We reserve the right to control, regulate, change or
      remove any Virtual Money and/or Virtual Goods without any liability to you at any time.
    </p>

    <p>
      4) You agree that once purchased Virtual Money and/or Virtual Goods have no monetary value and can never be
      exchanged for real money, real goods or real services from us or anyone else. You agree that Virtual Money and
      Virtual Goods are not transferable to anyone else and you will not transfer or attempt to transfer any Virtual
      Money or Virtual Goods to anyone else.
    </p>

    <p>
      5) You agree that all sales by us to you of Virtual Money and/or Virtual Goods are final, that we will not refund
      any transaction once it has been made. Prices for all Virtual Money and Virtual Goods exclude all applicable taxes
      and telecommunication charges, unless otherwise indicated. To the extent required by law, you agree to pay any
      such applicable taxes and telecommunication charges in line with applicable law. For the purposes of this
      paragraph, a "purchase" is complete at the time our servers validate your purchase and the applicable Virtual
      Goods and/or Virtual Money are successfully credited to your account on our servers.
    </p>

    <h3>Article 16 Tax</h3>

    <p>
      1) You are responsible for and will pay all fees and applicable taxes incurred by you or anyone using a Lilith
      Account registered to you.
    </p>

    <h3>Article 17 Copyright</h3>

    <p>
      1) The Company holds the copyrights and other intellectual property rights of any materials that are part of the
      Service, including but not limited to any content, websites, games, programs, tools, source codes, object codes,
      printed or electronic documentation, instructions, design, Accounts, passwords, themes, concepts, stories, story
      lines, logos, names, titles, methods of operation, software, related documentation, and all other features
      contained in our Services.
    </p>

    <p>
      2) You further acknowledge that any character data, game progress, game customization and/or other data pertaining
      to your use of our Services may cease to be available to you at any time without prior notice in the sole
      discretion of the Company.
    </p>

    <p>
      3) Any or all of our Services shall not be modified, copied, distributed, framed, reproduced, republished,
      downloaded, scraped, displayed, posted, transmitted, or sold in any form or by any means, in whole or in part, or
      otherwise exploited by any User without the Company’s express prior written permission.
    </p>

    <h3>Article 18 Termination of Contract</h3>

    <p>
      1) Without limiting any other rights of the Company, this Agreement will terminate automatically without prior
      notice if you fail to comply with any Terms or Conditions of this Agreement or any agreements or policies referred
      herein. In addition, the Company may notify authorities or take any other actions it deems appropriate, without
      notice to you, in the event of risks including but not limited to: (i) engaged in actions relating to or in the
      course of using our Services that may be illegal or cause liability, harm, embarrassment, harassment, abuse or
      disruption for you, other Users of the Service, the Company or any other third parties or our Services; and (ii)
      infringed the proprietary rights, rights of privacy, or Intellectual Property Rights of any person, including as a
      repeat infringer.
    </p>

    <p>
      2) You may also terminate this Agreement by deleting the Content from all devices on which you've installed and
      immediately stop your use of our Services. Upon any termination, you shall no longer exercise any of the rights
      granted to you and you must destroy all copies of the Content in your possession.
    </p>

    <h3>Article 19 Indemnity</h3>

    <p>
      1) The Company shall not be liable for any damages incurred by Users in connection with the Service provided by
      the Company free of charge.
    </p>

    <p>
      2) You agree to defend, indemnify, and hold the Company, its officers, employees and agents, harmless from and
      against any claims, liabilities, damages, losses, and expenses, including, without limitation, reasonable legal
      and accounting fees, arising out of or in any way connected with User Content you submit to us, your access to our
      Services or Content, or your violation of these Terms and Conditions.
    </p>

    <h3>Article 20 Severability</h3>

    <p>
      1) If any part of these terms is held to be invalid or unenforceable under any applicable local laws or by an
      applicable court, that part shall be interpreted in a manner consistent with applicable law to reflect as nearly
      as possible our original intentions and the remainder of these terms shall remain valid and enforceable. If it is
      not possible to interpret an invalid or unenforceable part of these terms in a manner consistent with applicable
      law, then that part shall be deemed deleted from these terms without affecting the remaining provisions of these
      terms.
    </p>

    <h3>Article 21 Dispute Resolution and Law</h3>

    <p>
      The interpretation and application of the terms of service and the rights and obligations between Members and the
      Company arising from the use of the Service shall be interpreted and applied in accordance with the laws of the
      Republic of China (excluding the applicable laws of foreign-related civil laws or other similar regulations). You
      agree that all disputes arising from these Terms of Service shall be submitted to the Hong Kong International
      Arbitration Center for arbitration in Hong Kong. The arbitration tribunal shall be composed of one person and the
      arbitration language shall be Chinese.
    </p>

    <h3>Article 22 Disclaimer</h3>

    <p>
      1) The Company shall not be liable for the provision of the Service in the event that it is unable to provide the
      Service due to force majeure including but not limited to strikes, lock-outs or other industrial disputes (other
      than any such dispute involving the workforce of the party so prevented), nuclear accident or acts of God, war or
      terrorist activity, riot, civil commotion, malicious damage (excluding malicious damage involving the employees of
      the affected party or its sub-contractors), compliance with any law or governmental order, rule, regulation or
      direction, industrial action by employees of any providers of electrical power, failure of technical facilities,
      hacking, denial of service or other IT attack, deployment of IT virus malware or similar technology, fire, flood,
      or storm or default of suppliers or sub-contractors.
    </p>

    <p>
      2) The Company shall not be liable for damage caused by unavoidable reasons such as maintenance, replacement,
      periodic inspection and construction of service facilities.
    </p>

    <p>
      3) The Company shall not be liable for the disability of the Service caused by Users. However, this shall not
      apply to Users if they are unavoidable or justifiable.
    </p>

    <p>
      4) The Company shall not be liable for the contents of information, data, facts, credibility, accuracy, etc.
      posted by Users or a third party in relation to the Service.
    </p>

    <p>
      5) The Company shall not be liable for any transaction between Users or Users and a third party through the
      Service.
    </p>

    <p>
      6) The Company shall not be liable for the use of the Service provided free of charge unless there are special
      regulations in the relevant laws.
    </p>

    <p>7) The Company shall not be liable for any loss or loss of profit that Users expect from using the Service.</p>

    <p>
      8) The Company shall not be liable for any loss of Users’ rating, Virtual Currency, Virtual Goods, etc., except
      when it is caused by negligence of the Company.
    </p>

    <p>
      9) The Company shall not be liable for any loss caused by settlement between Users or Users and a third party.
    </p>

    <p>
      10) In case of change of device, change of number, overseas roaming, move of carrier, etc., the Content may not be
      available in whole or in part, and Company shall not be held responsible.
    </p>

    <p>
      11) Please note that when deleting Content provided by the Company, the User information (score, character,
      in-game Virtual Currency, in-game Virtual Goods, etc.) may be deleted, for which the Company shall not be liable.
    </p>

    <h3>Article 23 Waivers of our rights</h3>

    <p>
      1) Our failure to exercise or enforce any of our rights under these terms does not waive our right to enforce such
      right. Any waiver of such rights shall only be effective if it is in writing and signed by us.
    </p>

    <h3>Article 24 General</h3>

    <p>
      1) This Agreement contains the entire contract of the parties regarding the subject matter of this Agreement, and
      this Agreement supersedes and replaces any prior written or oral agreements (if any) between you and the Company
      regarding our Services and Content.
    </p>

    <p>
      2) For matters not specified in these Terms and Conditions, the Company abides by the provisions of the Company's
      operating policy, restrictions on use, and other relevant laws and regulations.
    </p>

    <p>
      3) You represent that you are entering into this Agreement on a completely voluntary basis and you expect no
      compensation other than what is expressly granted under this Agreement.
    </p>

    <p>
      4) In case of any inconsistency between this Agreement and local laws of your country or residence, local laws
      shall prevail and govern.
    </p>

    <p>
      5) You may not assign or transfer any of these Terms and Conditions, by operation of law or otherwise, without the
      Company’s prior written consent. Any attempt by you to assign or transfer any of these Terms and Conditions,
      without such consent, will be of no effect.
    </p>

    <h3>Article 25 Contact</h3>

    <p>
      Should you have any questions regarding these Terms and Conditions, please contact us via email at
      cs_na@flame-games.com.
    </p>
  </div>
</template>

<script>
export default {}
</script>

<style lang="less" scoped>
.service {
  max-width: 800px;
  margin: 0.1rem auto;
  font-family: 'Helvetica Neue', Arial, 'Hiragino Sans GB', 'STHeiti', 'Microsoft YaHei', 'WenQuanYi Micro Hei', SimSun,
    Song, sans-serif;
  color: #2c3f51;
  line-height: 1.8;
  h2 {
    font-size: 22px;
    text-align: center;
  }
  p {
    font-size: 16px;
    margin-top: 20px;
  }
  h3 {
    font-size: 20px;
    margin: 20px 0;
  }
  h4 {
    font-size: 18px;
    margin: 20px 0;
    font-weight: 400;
  }
}
</style>
